import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Skeleton, Button, Typography } from '@mui/material';

import GameCard from 'components/sections/GameCard';
import AspectRatio, { AspectRatioWrapper } from 'components/common/AspectRatio';

import { CasinoService, IGame } from 'api/casino';
import useScreen from 'hooks/useScreen';
import useTranslates from 'utils/translate';

const sx = {
  root: ({ isMobile }) => ({
    p: isMobile ? 2 : 3,
    borderRadius: !isMobile && '20px',
    bgcolor: 'background.paper',
  }),
};

interface GamesGroupProps {
  title: string;
  allPath?: string;
  categoryId: number;
}

const GamesGroup: FC<GamesGroupProps> = ({ title, allPath, categoryId }) => {
  const navigate = useNavigate();
  const { translate } = useTranslates();
  const { isMobile, is13Inch } = useScreen();

  const [games, setGames] = useState<IGame[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const size = is13Inch ? 18 : 16;

  useEffect(() => {
    CasinoService.getGames({ category: categoryId, size, page: 1 }).then(({ data }) => {
      data?.length && setGames(data);
      setIsLoading(false);
    });
  }, [categoryId]);

  return (
    <Box sx={sx.root({ isMobile })}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography fontSize={isMobile ? 12 : 18} fontWeight={600}>
          {translate(title)}
        </Typography>
        {allPath && <Button onClick={() => navigate(allPath)}>{translate('show_all')}</Button>}
      </Box>

      <AspectRatioWrapper>
        {games.map((item) => (
          <AspectRatio key={item.id} size={is13Inch ? 3 : 4} spacing={isMobile ? 0.5 : 1}>
            <GameCard game={item} height="100%" />
          </AspectRatio>
        ))}
        {isLoading &&
          Array(size)
            .fill('')
            .map((_, index) => (
              <AspectRatio key={index} size={is13Inch ? 3 : 4}>
                <Skeleton width="100%" height="100%" />
              </AspectRatio>
            ))}
      </AspectRatioWrapper>
    </Box>
  );
};

export default GamesGroup;
